import React, { useContext, useState, useEffect } from 'react';
import { FormGroupLabel } from '@/shared/components/form/FormElements';
import { Field } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import { IoIosRemoveCircle } from 'react-icons/io';
import Select from 'react-select';
import { Table } from '@/shared/components/TableElements';
import styled from 'styled-components';
import { BookingContext } from '../../../../../../context/BookingContext';

// Styled-components for styling
const Container = styled.div`
  background-color: #f7f7f7;
  min-height: 47vh;
`;

const PaxDetailsCardWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const FormSection = styled.div`
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #d1d1d1;
  max-height: 300px;
  overflow-y: auto;
`;

const TableWrapper = styled.div`
  max-height: 300px;
  overflow-y: auto;
  margin-top: 20px;
`;

const ReactSelect = styled(Select)`
  width: 100%;
  border-radius: 4px;
  border: 1px solid #d1d1d1;
  font-size: 12px;
  &:hover {
    border-color: #007bff;
  }
`;

const InputField = styled.input`
  width: 100%;
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid #d1d1d1;
  font-size: 12px;
  margin-bottom: 10px;
  &:focus {
    border-color: #007bff;
    outline: none;
  }
`;

const ButtonRemove = styled(Button)`
  color: red;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
`;

const ButtonAdd = styled(Button)`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  font-size: 14px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  width: 100%;
  margin-top: 10px;
  &:hover {
    background-color: #0056b3;
  }
`;

const FormGroupLabelStyled = styled(FormGroupLabel)`
  font-weight: 500;
  color: #495057;
  margin-bottom: 5px;
  font-size: 12px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const MultipleInputsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 15px;
`;

const InputGroup = styled.div`
  margin-bottom: 5px;
`;

const InputLabel = styled.label`
  display: block;
  font-size: 12px;
  margin-bottom: 3px;
  color: #495057;
`;

const PaxDetailsCard = () => {
  const [itemValue, setItemValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const [typeSelect, setTypeSelect] = useState(null);
  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [selectControl, setSelectControl] = useState('1');
  const { paxs, setPaxs } = useContext(BookingContext);
  
  // New states for "Create by No" option
  const [adultCount, setAdultCount] = useState('');
  const [childCount, setChildCount] = useState('');
  const [adultInputs, setAdultInputs] = useState([]);
  const [childInputs, setChildInputs] = useState([]);

  

  const generateInputFields = () => {
    // Count existing adults and children in `paxs`
    const existingAdults = paxs.filter(p => p.age_group === '1').length;
    const existingChildren = paxs.filter(p => p.age_group === '2').length;
  
    // Generate adult input fields starting from existing count
    const newAdultInputs = [];
    // eslint-disable-next-line
    for (let i = 0; i < parseInt(adultCount) || 0; i++) {
      newAdultInputs.push({
        id: `adult_${existingAdults + i}`,
        name: `Adult ${existingAdults + i + 1}`,
        value: '',
        type: '1', // Adult type
      });
    }
    setAdultInputs(newAdultInputs);
  
    // Generate child input fields starting from existing count
    const newChildInputs = [];
      // eslint-disable-next-line
    for (let i = 0; i < parseInt(childCount) || 0; i++) {
      newChildInputs.push({
        id: `child_${existingChildren + i}`,
        name: `Child ${existingChildren + i + 1}`,
        value: '',
        type: '2', // Child type
      });
    }
    setChildInputs(newChildInputs);
  };
  

  useEffect(() => {
    if (selectControl === '2') {
      generateInputFields();
    }
  }, [adultCount, childCount]);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhone = (phone) => {
    const regex = /^\d{10}$/;
    return regex.test(phone);
  };

  const handleAddMeal = () => {
    if (selectControl === '1') {
      if (!typeSelect) {
        alert('Please Select Type');
        return;
      }

      const pax = {
        item_id: Date.now(),
        pax_name: itemValue.trim(),
        email_id: emailValue.trim(),
        mobile_no: phoneValue.trim(),
        age_group: typeSelect.value,
        age_group_name: typeSelect.label,
      };

      setPaxs(prevPaxs => [...prevPaxs, pax]);

      setItemValue('');
      setEmailValue('');
      setPhoneValue('');
      setTypeSelect(null);
    } else {
      // Add all adults and children from the input fields
      const allInputs = [...adultInputs, ...childInputs];
      const newPaxs = allInputs.map(input => ({
          item_id: Date.now() + Math.random(),
          pax_name: input.value || input.name,
          email_id: '',
          mobile_no: '',
          age_group: input.type,
          age_group_name: input.type === '1' ? 'Adult' : 'Child',
        }));

      setPaxs(prevPaxs => [...prevPaxs, ...newPaxs]);
      
      // Reset the inputs
      setAdultCount('');
      setChildCount('');
      setAdultInputs([]);
      setChildInputs([]);
    }
  };

  const handleRemoveMeal = (paxId) => {
    setPaxs(prevPaxs => prevPaxs.filter(pax => pax.item_id !== paxId));
  };

  const handleSelectChange = (selectedOption) => {
    setTypeSelect(selectedOption);
  };

  const handleselectControl = (e) => {
    const { value } = e.target;
    setSelectControl(value);
    
    // Reset form values when switching between modes
    setItemValue('');
    setEmailValue('');
    setPhoneValue('');
    setTypeSelect(null);
    setAdultCount('');
    setChildCount('');
    setAdultInputs([]);
    setChildInputs([]);
  };

  const handleInputChange = (id, value, isAdult) => {
    if (isAdult) {
      setAdultInputs(prev => prev.map(input => (input.id === id ? { ...input, value } : input)));
    } else {
      setChildInputs(prev => prev.map(input => (input.id === id ? { ...input, value } : input)));
    }
  };

  return (
    <Container>
      <PaxDetailsCardWrapper>
        <FormSection>
          <div className="mb-2">
            <select className="form-select" onChange={e => handleselectControl(e)} value={selectControl}>
              <option value="1">Create by Name</option>
              <option value="2">Create by No</option>
            </select>
          </div>
          
          {selectControl === '1' && (
            <FormRow>
              <Column>
                <FormGroupLabelStyled>Name<span style={{ color: 'red' }}>*</span></FormGroupLabelStyled>
                <InputField
                  type="text"
                  placeholder="Enter Name"
                  value={itemValue}
                  onChange={e => setItemValue(e.target.value)}
                />
                <FormGroupLabelStyled>Email</FormGroupLabelStyled>
                <InputField
                  type="email"
                  placeholder="Enter Email"
                  value={emailValue}
                  onChange={(e) => {
                    setEmailValue(e.target.value);
                    if (e.target.value && !validateEmail(e.target.value)) {
                      setEmailError('Please enter a valid email address.');
                    } else {
                      setEmailError('');
                    }
                  }}
                />
                {emailError && <span style={{ color: 'red', fontSize: '12px' }}>{emailError}</span>}
              </Column>

              <Column>
                <FormGroupLabelStyled>Phone No.</FormGroupLabelStyled>
                <InputField
                  type="text"
                  placeholder="Enter phone number"
                  value={phoneValue}
                  maxLength={10}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replace(/\D/g, '');
                    setPhoneValue(onlyDigits);
                    if (onlyDigits && !validatePhone(onlyDigits)) {
                      setPhoneError('Please enter a valid phone number.');
                    } else {
                      setPhoneError('');
                    }
                  }}
                />
                {phoneError && <span style={{ color: 'red', fontSize: '12px' }}>{phoneError}</span>}
                <FormGroupLabelStyled>Type<span style={{ color: 'red' }}>*</span></FormGroupLabelStyled>
                <Field
                  name="age_group"
                  render={({ input }) => (
                    <ReactSelect
                      {...input}
                      name="age_group"
                      options={[
                        { value: '1', label: 'Adult' },
                        { value: '2', label: 'Child' },
                      ]}
                      placeholder="Select Age Group"
                      value={typeSelect}
                      onChange={(selectedOption) => {
                        input.onChange(selectedOption ? selectedOption.value : '');
                        handleSelectChange(selectedOption);
                      }}
                      menuPlacement="top"
                    />
                  )}
                  required
                />
              </Column>
            </FormRow>
          )}
          
          {selectControl === '2' && (
            <div>
              <FormRow>
                <Column>
                  <FormGroupLabelStyled>
                    Enter no Pax (Adult)<span style={{ color: 'red' }}>*</span>
                  </FormGroupLabelStyled>
                  <InputField
                    type="number"
                    min="0"
                    placeholder="Enter number of Adults"
                    value={adultCount}
                    onChange={e => setAdultCount(e.target.value)}
                  />
                </Column>
                <Column>
                  <FormGroupLabelStyled>
                    Enter no Pax (Child)<span style={{ color: 'red' }}>*</span>
                  </FormGroupLabelStyled>
                  <InputField
                    type="number"
                    min="0"
                    placeholder="Enter number of Children"
                    value={childCount}
                    onChange={e => setChildCount(e.target.value)}
                  />
                </Column>
              </FormRow>
              
              {/* Display input fields for adults */}
              {adultInputs.length > 0 && (
                <>
                  <FormGroupLabelStyled>Adult Details</FormGroupLabelStyled>
                  <MultipleInputsContainer>
                    {adultInputs.map(input => (
                      <InputGroup key={input.id}>
                        <InputLabel>{input.name}</InputLabel>
                        <InputField 
                          type="text" 
                          placeholder={`Enter name for ${input.name}`}
                          value={input.value}
                          onChange={e => handleInputChange(input.id, e.target.value, true)}
                        />
                      </InputGroup>
                    ))}
                  </MultipleInputsContainer>
                </>
              )}
              
              {/* Display input fields for children */}
              {childInputs.length > 0 && (
                <>
                  <FormGroupLabelStyled>Child Details</FormGroupLabelStyled>
                  <MultipleInputsContainer>
                    {childInputs.map(input => (
                      <InputGroup key={input.id}>
                        <InputLabel>{input.name}</InputLabel>
                        <InputField 
                          type="text" 
                          placeholder={`Enter name for ${input.name}`}
                          value={input.value}
                          onChange={e => handleInputChange(input.id, e.target.value, false)}
                        />
                      </InputGroup>
                    ))}
                  </MultipleInputsContainer>
                </>
              )}
            </div> 
          )}
        </FormSection>

        <TableWrapper>
          <Table responsive hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone No.</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paxs.map((pax, index) => (
                <tr key={pax.item_id}>
                  <td>{index + 1}</td>
                  <td>{pax.pax_name}</td>
                  <td>{pax.email_id}</td>
                  <td>{pax.mobile_no}</td>
                  <td>{pax.age_group_name}</td>
                  <td>
                    <ButtonRemove
                      type="button"
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleRemoveMeal(pax.item_id)}
                    >
                      <IoIosRemoveCircle />
                    </ButtonRemove>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

        <ButtonAdd onClick={handleAddMeal}>Add Pax</ButtonAdd>
      </PaxDetailsCardWrapper>
    </Container>
  );
};

export default PaxDetailsCard;
